import React from "react"
import "./courses.css"
import { faculties } from "../../dummydata"
import Heading from "../common/heading/Heading"

const Faculties = () => {
  return (
  <section className="faculties dark">
      <div className='container'>
    <Heading subtitle='FACULTIES' title='Our Faculties & Programmes' />
        <div className='content grid2'>
          {faculties.map((fac, idx) => (
            <div className='box' key={`fac-${idx}`}>
              <h2 className='title'>{fac.name}</h2>
              <ul>
                {fac.programmes.map((p, pIdx) => (
                  <li key={`fac-${idx}-p-${pIdx}`}>{p}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Faculties
